import { render, staticRenderFns } from "./SelectAccordion.vue?vue&type=template&id=7966a620&scoped=true&"
import script from "./SelectAccordion.vue?vue&type=script&lang=js&"
export * from "./SelectAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7966a620",
  null
  
)

export default component.exports